<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">View Schedule</h4>
                    </div>
                    <div class="card-body">
                        <CircleLoader v-if="isLoading" />
                        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange"
                            v-else
                            :totalRows="totalRecords" :isLoading.sync="isLoading"
                            :pagination-options="{ enabled: true, dropdownAllowAll: false, perPageDropdown: [10, 20, 50, 100, 200], }"
                            :rows="rows" :sort-options="{
                                enabled: false,
                            }" :columns="columns">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field === 'action'" class="text-nowrap">
                                    <b-button size="sm" @click="updateScheduler(props.row.ContentID)"
                                        class="mr-1 btn-info text-white">
                                        Edit
                                    </b-button>
                                    <b-button size="sm" @click="DeleteScheduler(props.row.ContentID)"
                                        class="mr-1 btn-danger text-white">
                                        Delete
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue from "vue";
import VueJsonToCsv from 'vue-json-to-csv'
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import moment from 'moment'
import CircleLoader from '@/pages/loaders/CircleLoader.vue'; 

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Scheduling',
    data() {
        return {
            isDisabled: false,
            selected: true,
            unSelected: false,
            serverParams: {
                sort: [
                    {
                        field: 'mail_sent_date', // example: 'name'
                        type: 'asc' // 'asc' or 'desc'
                    }
                ],
                page: 1, // what page I want to show
                perPage: 10
            },
            columns: [
                {
                    label: 'Template',
                    field: 'template',
                    filterable: false,
                },
                {
                    label: 'Title',
                    field: 'title',
                    sortable: false,
                },
                {
                    label: 'Group',
                    field: "group",
                    sortable: false,
                },
                {
                    label: 'Last Send Date',
                    field: "lastSendDate",
                    sortable: false,
                },
                {
                    label: '# of Emails',
                    field: "emails",
                    sortable: false,
                },
                {
                    label: 'Action',
                    field: "action",
                    sortable: false,
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: [],
            CSVData: []
        };
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.getNewMarketingContent();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.getNewMarketingContent();
        },
        getNewMarketingContent() {
            API.getNewMarketingContent(this.serverParams, res => {
                this.totalRecords = res.data.totalNumber
                console.log(res.data.totalNumber)
                let data = res.data.data.data.map((element, index) => {
                    return {
                        template: index,
                        title: `NewEmailmarketing-${element.GroupID}-${element.ContentID}-${element.StartDate}`,
                        group: this.groupTitle(element.GroupID),
                        lastSendDate: moment(element.mail_sent_date).format('mmmm DD, Y'),
                        emails: element.of_emails,
                        action: '',
                        ContentID: element.ContentID
                    }
                });
                this.rows = data;
                this.isLoading = false;
            }, err => {
                console.log(err);
                this.isLoading = false;
            })
        },
        updateScheduler(id) {
            this.$router.push({ name: "update_schedule_email", params: { id } });
        },
        DeleteScheduler(id) {
            this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value == true) {
                    API.deleteScheduler({ ContentID: id }, res => {
                        this.getNewMarketingContent();
                    }, err => {
                        console.log(err);
                    })
                }
                console.log(result);
            })
        },
        groupTitle(GroupID) {
            if (GroupID == 1) {
                return "Futures1";
            } else if (GroupID == 2) {
                return "Futures2";
            } else if (GroupID == 3) {
                return "Currents";
            } else if (GroupID == 4) {
                return "Pasts";
            } else {
                return "Custom";
            }
        }
    },
    computed: {}
    ,
    mounted() {
        this.isLoading = true;
        this.getNewMarketingContent()
    }
}
</script>
